import React from 'react';
import PropTypes from 'prop-types';
import Styled from './DataGrid.styles';

const DataGridColumns = ({ columns }) => (
  <Styled.HeaderColumns>
    <Styled.HeaderRow>
      {columns.map((c, idx) => (
        <Styled.HeaderColumn key={idx}>{c}</Styled.HeaderColumn>
      ))}
    </Styled.HeaderRow>
  </Styled.HeaderColumns>
);

DataGridColumns.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default React.memo(DataGridColumns);
